import React from "react"

export default () => (
    <svg
        height="6"
        viewBox="0 0 10 6"
        width="10"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        version="1"
    >
        <title>Chevron</title>
        <desc>Chevron</desc>
        <path
            d="m775.437624 34.3484619-.796496.8203036 3.710053 3.8208232-3.710053 3.8208232.796496.8203035 4.506575-4.6411267z"
            
            transform="matrix(0 1 -1 0 44.282252 -774.303074)"
        />
    </svg>
)
